import { ADP_CONFIG } from './constants/adp';
import { ADP_1099_CONFIG } from './constants/adp1099';
import { getAmendmentConfig } from './constants/amendment';
import { getAnnualReportConfig } from './constants/annualReport';
import { BANK_OF_AMERICA_CONFIG } from './constants/bankOfAmerica';
import { BASIC_EMAIL_CONFIG } from './constants/basicEmail';
import { BUSINESS_CREDIT_CARDS_CONFIG } from './constants/businessCreditCard';
import { BUSINESS_KIT_CONFIG } from './constants/businessKit';
import { BUSINESS_LICENSES_CONFIG } from './constants/businessLicense';
import { BUSINESS_LICENSE_FILING_CONFIG } from './constants/businessLicenseFiling';
import { CHANGE_OF_REGISTERED_AGENT_CONFIG } from './constants/changeOfregisteredAgent';
import { CONSTANT_CONTACT } from './constants/constantContact';
import { CORP_FORMATION_CONFIG } from './constants/corpFormation';
import { CORPORATE_BYLAWS_CONFIG } from './constants/corporateBylaws';
import { CORPORATE_DOCS_CONFIG } from './constants/corporateDocs';
import { DBA_ENTITY_CONFIG } from './constants/dbaEntity';
import { getDomainNameRegConfig } from './constants/domainNameReg';
import { EIN_CONFIG } from './constants/ein';
import { FUNDBOX_CONFIG } from './constants/fundbox';
import { GUSTO_CONFIG } from './constants/gusto';
import { INITIAL_REPORT_CONFIG } from './constants/initialReport';
import { IPOSTAL1_CONFIG } from './constants/iPostal1';
import { LEGAL_SHIELD_CONFIG } from './constants/legalShield';
import { LLC_FORMATION_CONFIG } from './constants/llcFormation';
import { LOGO_KIT_CONFIG } from './constants/logoKit';
import { NEXT_INSURANCE_CONFIG } from './constants/nextInsurance';
import { NY_PUBLICATION_CONFIG } from './constants/nyPublication';
import { OCOYA_CONFIG } from './constants/ocoya';
import { OPERATING_AGREEMENT_CONFIG } from './constants/operatingAgreement';
import { QUARTERLY_TAX_PLANNING_CONFIG } from './constants/quarterlyTaxPlanning';
import { REGISTERED_AGENT_CONFIG } from './constants/registeredAgent';
import { SALES_TAX_REGISTRATION_CONFIG } from './constants/salesTaxRegistration';
import { getSCorpBundleConfig } from './constants/sCorpBundle';
import { S_CORP_DESIGNATOR } from './constants/sCorpDesignator';
import { SHOPIFY_CONFIG } from './constants/shopify';
import { STANDARD_GOOD_STANDING_CONFIG } from './constants/standardGoodStanding';
import { STATIC_WEBSITE_CONFIG } from './constants/staticWebsite';
import { STATIC_WEBSITE_SQSP_CONFIG } from './constants/staticWebsiteSqsp';
import { TAX_ADVICE_CONFIG } from './constants/taxAdvice';
import { TAX_FILING_CONFIG } from './constants/taxFiling';
import { TRADEMARKS_SEARCH_CONFIG } from './constants/trademark';
import { VELO_PRIME_CONFIG } from './constants/veloPrime';
import { WEBSITE_TOOLS_BUNDLE_CONFIG } from './constants/websiteToolsBundle';
import { WFC_ADVANCED_CONFIG } from './constants/wfcAdvanced';
import { WFC_SERVICES_CONFIG } from './constants/wfcServices';
import { ZB_MONEY_PRO_CONFIG } from './constants/zbMoneyPro';

const landingPageConfigMapping = {
  adp: ADP_CONFIG,
  'adp-1099': ADP_1099_CONFIG,
  amendment: getAmendmentConfig,
  'annual-report': getAnnualReportConfig,
  'basic-email': BASIC_EMAIL_CONFIG,
  'business-credit-card': BUSINESS_CREDIT_CARDS_CONFIG,
  'business-kit': BUSINESS_KIT_CONFIG,
  'business-licenses': BUSINESS_LICENSES_CONFIG,
  'business-license-report': BUSINESS_LICENSES_CONFIG,
  'business-license-filing': BUSINESS_LICENSE_FILING_CONFIG,
  'change-of-registered-agent': CHANGE_OF_REGISTERED_AGENT_CONFIG,
  'constant-contact': CONSTANT_CONTACT,
  'corp-formation': CORP_FORMATION_CONFIG,
  'corporate-bylaws': CORPORATE_BYLAWS_CONFIG,
  'corporate-docs': CORPORATE_DOCS_CONFIG,
  'dba-entity': DBA_ENTITY_CONFIG,
  'domain-name-reg': getDomainNameRegConfig,
  'ein-creation': EIN_CONFIG,
  fundbox: FUNDBOX_CONFIG,
  gusto: GUSTO_CONFIG,
  'initial-report': INITIAL_REPORT_CONFIG,
  ipostal1: IPOSTAL1_CONFIG,
  'legal-shield': LEGAL_SHIELD_CONFIG,
  'llc-formation': LLC_FORMATION_CONFIG,
  'money-pro': ZB_MONEY_PRO_CONFIG,
  'next-insurance': NEXT_INSURANCE_CONFIG,
  'ny-publication': NY_PUBLICATION_CONFIG,
  ocoya: OCOYA_CONFIG,
  'operating-agreement': OPERATING_AGREEMENT_CONFIG,
  'registered-agent': REGISTERED_AGENT_CONFIG,
  'standard-good-standing': STANDARD_GOOD_STANDING_CONFIG,
  'sales-tax-registration': SALES_TAX_REGISTRATION_CONFIG,
  's-corp-bundle': getSCorpBundleConfig,
  's-corp-designator': S_CORP_DESIGNATOR,
  shopify: SHOPIFY_CONFIG,
  'tax-advice': TAX_ADVICE_CONFIG,
  'quarterly-tax-planning': QUARTERLY_TAX_PLANNING_CONFIG,
  'tax-filing': TAX_FILING_CONFIG,
  'trademarks-search': TRADEMARKS_SEARCH_CONFIG,
  'velo-prime': VELO_PRIME_CONFIG,
  'website-tools-bundle': WEBSITE_TOOLS_BUNDLE_CONFIG,
  'wfc-advanced': WFC_ADVANCED_CONFIG,
  'wfc-services': WFC_SERVICES_CONFIG,
  'logo-kit': LOGO_KIT_CONFIG,
  'static-website': STATIC_WEBSITE_CONFIG,
  'static-website-sqsp': STATIC_WEBSITE_SQSP_CONFIG,
  'bank-of-america': BANK_OF_AMERICA_CONFIG,
};

// Get product details based on productId from the landing page configuration
const getProductDetails = (productId) => landingPageConfigMapping[productId];
export default getProductDetails;
